var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#effafe;}.cls-2{fill:#40bdff;}.cls-3{fill:#e4ebed;}.cls-4{fill:#2197f7;}.cls-5{fill:#263238;}.cls-6{fill:#fd0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "laptop job seeker employee unemployee work_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.92,143.62l-.38.73H205.47l-.38-.73a68.84,68.84,0,0,0-61.18-37.08H120.1A68.84,68.84,0,0,0,58.92,143.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.19,148.35H43.81A8,8,0,0,0,36,157.89l13.57,69.34a8,8,0,0,0,7.85,6.46H206.63a8,8,0,0,0,7.85-6.46L228,157.89A8,8,0,0,0,220.19,148.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.66,102.54h0a45.4,45.4,0,1,0-9.31,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M205.08,143.62a68.84,68.84,0,0,0-61.18-37.08h-10a68.84,68.84,0,0,1,61.18,37.08l.38.73h10Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.19,148.35h-10a8,8,0,0,1,7.85,9.54l-13.57,69.35a8,8,0,0,1-7.85,6.46h10a8,8,0,0,0,7.85-6.46L228,157.89A8,8,0,0,0,220.19,148.35Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132,12a45.64,45.64,0,0,0-5,.28,45.38,45.38,0,0,1,0,90.21l.36,0h9.31A45.39,45.39,0,0,0,132,12Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49.78,143.85h-10a12.5,12.5,0,0,0-12.27,14.9L41.11,228.1a12.53,12.53,0,0,0,12.27,10.1H202.63a12.52,12.52,0,0,0,12.27-10.1l13.57-69.34a12.5,12.5,0,0,0-12.27-14.9h-10A73.71,73.71,0,0,0,149,102.62a49.89,49.89,0,1,0-42,0A73.7,73.7,0,0,0,49.78,143.85Zm166.41,5a7.5,7.5,0,0,1,7.36,8.94L210,227.14a7.51,7.51,0,0,1-7.36,6.06H53.37A7.51,7.51,0,0,1,46,227.14L32.45,157.79a7.5,7.5,0,0,1,7.36-8.94H216.19ZM83.11,57.39A44.89,44.89,0,1,1,132.63,102h-9.26A45,45,0,0,1,83.11,57.39Zm33,49.65H139.9a68.67,68.67,0,0,1,60.74,36.81H55.36A68.67,68.67,0,0,1,116.1,107Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M228.35,243.5H27.65a2.5,2.5,0,0,0,0,5h200.7a2.5,2.5,0,1,0,0-5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.15,12.19v4h-4a1,1,0,0,0,0,2h4v4a1,1,0,0,0,2,0v-4h4a1,1,0,0,0,0-2h-4v-4a1,1,0,1,0-2,0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226,118.39v4h-4a1,1,0,0,0,0,2h4v4a1,1,0,0,0,2,0v-4h4a1,1,0,0,0,0-2h-4v-4a1,1,0,0,0-2,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M43,101.54v4H39a1,1,0,0,0,0,2h4v4a1,1,0,1,0,2,0v-4h4a1,1,0,1,0,0-2H45v-4a1,1,0,0,0-2,0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.54,48a6,6,0,1,1-6-6A6,6,0,0,1,30.54,48Zm-10,0a4,4,0,1,0,4-4A4,4,0,0,0,20.54,48Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.94,197.29a6,6,0,1,1-6-6A6,6,0,0,1,238.94,197.29Zm-10,0a4,4,0,1,0,4-4A4,4,0,0,0,228.94,197.29Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.5082018f0d883aef73630e7f8e653f24.svg";
export { ForwardRef as ReactComponent };